import React from 'react'

function index() {
  return (
    <div>Bulk SMS</div>
  )
}

export default index